import controller from './wf-affect-list.controller';
import template from './wf-affect-list.html';
import './wf-affect-list.scss';

export default {
	controller,
	template,
	bindings: {
		disabled:     '<ngDisabled',
		form:         '<',
		kid:          '<',
		modelActions: '<',
		data:         '<ngModel',
	},
	require: {
		kform: '^^?kform',
	},
};
